import { useQuery } from 'react-query';
import { toast } from 'react-toastify';
import { SrxApi } from '../../api/SrxApi';

const useGetDischargePatients = (facId) => {
    const { data, isLoading, refetch } = useQuery(
        ['dischargePatients', facId],
        async () => {
            const response = await SrxApi.get(`/dischargesummary/patients?FacId=${facId}`);

            return response?.data?.data ?? response?.data ?? [];
        },
        {
            enabled: false,
            onError: (error) => {
                const errorMessage = error?.response?.data?.message || error?.message || 'Failed to fetch patients';

                toast.error(errorMessage);
            },
        }
    );

    return {
        patients: data,
        isGetDischargePatientsLoading: isLoading,
        getDischargePatients: refetch,
    };
};

export default useGetDischargePatients;
